import request from '@/utils/request'

function QUERY( {key, params}) {
  let url
  if(key=='Diagnostic'){
    url = '/h5/Diagnostic/index'
  }

  if (typeof params == 'object') {
    params['version'] = 'MINI'
  } else {
    params = { version: 'MINI' }
  }
  return request({
    url,
    method: 'post',
    params
  })
}

export default QUERY;